import { render, staticRenderFns } from "./BosInput.vue?vue&type=template&id=78d07974&scoped=true"
import script from "./BosInput.vue?vue&type=script&lang=js"
export * from "./BosInput.vue?vue&type=script&lang=js"
import style0 from "./BosInput.vue?vue&type=style&index=0&id=78d07974&prod&lang=scss&scoped=true"
import style1 from "./BosInput.vue?vue&type=style&index=1&id=78d07974&prod&lang=css"
import style2 from "./BosInput.vue?vue&type=style&index=2&id=78d07974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d07974",
  null
  
)

export default component.exports